import { PlusOutlined } from "@ant-design/icons"
import { Button, Flex } from "antd"
import React, { useCallback } from "react"
import { Link } from "react-router-dom"

import { SearchBar } from "../../../components/Input/SearchBar.tsx"
import { homeSize } from "../home-theme.ts"
import { RoutesPaths } from "../../../constants/routes.ts"
import { useAppDispatch } from "../../../hooks/use-app-dispatch.ts"
import { useAppSelector } from "../../../hooks/use-app-selector.ts"
import { dashboardSetProp } from "../redux/dashboard.slice.ts"
import type { DashboardState } from "../redux/dashboard.types.ts"

export type DashboardTableFilterKey = keyof Pick<
  DashboardState,
  "leadFilters" | "projectFilters"
>

const settings: Record<
  DashboardTableFilterKey,
  {
    placeholder: string
    href: string
    buttonName: string
  }
> = {
  leadFilters: {
    placeholder: "Search leads...",
    href: RoutesPaths.lead.add,
    buttonName: "New Lead"
  },
  projectFilters: {
    placeholder: "Search projects...",
    href: RoutesPaths.project.add,
    buttonName: "New Project"
  }
}

interface DashboardHeaderSearchProps {
  canCreate: boolean
  tableFilterKey: DashboardTableFilterKey
}

export function DashboardHeaderSearch({
  tableFilterKey,
  canCreate
}: DashboardHeaderSearchProps) {
  const dispatch = useAppDispatch()
  const filters = useAppSelector((state) => state.dashboard?.[tableFilterKey])

  const setting = settings?.[tableFilterKey]

  const handleSearch = useCallback(
    (q: string | null) => {
      dispatch(
        dashboardSetProp({ key: tableFilterKey, value: { ...filters, q } })
      )
    },
    [filters, dispatch, tableFilterKey]
  )

  return (
    <Flex gap={8} align="center" className={"max-lg:w-full"}>
      <SearchBar
        defaultValue={filters?.q || ""}
        onSearch={handleSearch}
        placeholder={setting?.placeholder}
        style={{ maxWidth: 280, height: homeSize.controlHeight }}
      />

      {canCreate && (
        <Link to={setting?.href}>
          <Button
            type={"primary"}
            icon={<PlusOutlined />}
            style={{
              height: homeSize.controlHeight,
              borderRadius: homeSize.controlRadius
            }}
          >
            {setting?.buttonName}
          </Button>
        </Link>
      )}
    </Flex>
  )
}
